<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <vx-card title="Relatório Intervalo - Por Pedido">
      <div class="vx-row">
          <div class="vx-col md:w-1/2 w-1/2 mt-5">
          <h6 class="mb-2">Data Inicial</h6>
          <div>
            <datepicker
              placeholder="Selecione a Data Inicial"
              :language="languages['ptBR']"
              format="dd/MM/yyyy"
              v-model="dateInitial"
            ></datepicker>
          </div>
        </div>
           <div class="vx-col md:w-1/2 w-1/2 mt-5">
          <h6 class="mb-2">Data Final</h6>
          <div>
            <datepicker
              placeholder="Selecione a Data Final"
              :language="languages['ptBR']"
              format="dd/MM/yyyy"
              v-model="dateFinal"
            ></datepicker>
          </div>
        </div>
      </div>
      <div class="vx-row">
       <div class="vx-col md:w-1/2 w-1/2 mt-5">
          <h6 class="mb-2">Consultor</h6>
          <v-select
            name="user"
            v-model="userSelected"
            :options="getUsers"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-validate="'required'"
          />
          <span class="text-danger">{{ errors.first("user") }}</span>
        </div>
      </div>
      <br />
      <vs-button color="#1E90FF" type="filled" @click="submit">Gerar</vs-button>
    </vx-card>
    <br />
    <br />
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import { Validator } from "vee-validate";
import vSelect from "vue-select";
import { momentJS } from "@/helpers";
import axios from "axios";
import { baseApiUrl } from "@/global";
const dict = {
  custom: {
    user: {
      required: "Selecione o Consultor",
    },
  },
};
Validator.localize("en", dict);
export default {
  components: {
    Datepicker,
    vSelect,
  },
  data() {
    return {
      dateInitial: null,
      dateFinal: null,
      languages: lang,
      customerSelected: [],
      userSelected: null,
      moment: null,
    };
  },
  computed: {
    getUsers() {
      return this.$store.state.usersFiltered;
    },
  },
  methods: {
    async submit() {
      const haveErrors = !(await this.$validator.validateAll());
      if (haveErrors) return;
      let dateInitial = this.moment.formatPTBRForMYSQL(this.dateInitial);
      let dateFinal = this.moment.formatPTBRForMYSQL(this.dateFinal);
      try {
        this.$vs.loading();
        let res = await axios.get(
          `${baseApiUrl}/suppliesOrder/intervalReportByOrder?&idUser=${this.userSelected.id}
        &dateInitial=${dateInitial}
        &dateFinal=${dateFinal}`,
          { responseType: "blob" }
        );

        let blob = new Blob([res.data], { type: "application/pdf" }),
          url = window.URL.createObjectURL(blob);
        window.open(url);
      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel salvar " + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  async created() {
    this.moment = momentJS();
    this.dateInitial = this.moment.getDateTimeLocal();
    this.dateFinal = this.dateInitial;

  },
};
</script>

<style lang="scss">
</style>
